
import CameraSlash from "../../../assets/duotone/CameraSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CameraSlashIcon({ className, dataTestid = "CameraSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CameraSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
